import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Features from "./pages/Features";
import Auth from "./pages/Auth";
import Chat from "./pages/Chat";
import ChatEnhanced from "./pages/ChatEnhanced";
import Automation from "./pages/Automation";
import ModelDatabase from "./pages/ModelDatabase";
import APISettings from "./pages/APISettings";
import WebsiteGenerator from "./pages/WebsiteGenerator";
import Examples from "./pages/Examples";
import Order from "./pages/Order";
import AdminModels from "./pages/AdminModels";
import AdminDashboard from "./pages/AdminDashboard";
import Upgrade from "./pages/Upgrade";
import AuthReset from "./pages/AuthReset";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Refund from "./pages/Refund";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import MrSupport from "./components/MrSupport";
import { Toaster } from "./components/ui/toaster";

function Shell() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";   // the new landing is self-contained (its own nav + footer)
  return (
    <>
      {!isHome && <Navbar />}
      <div className={isHome ? "" : "pt-16"}>
        <Routes>
          <Route path="/" element={<Home />} />
              <Route path="/features" element={<Features />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/website-generator" element={<WebsiteGenerator />} />
              <Route path="/examples" element={<Examples />} />
              <Route path="/order" element={<Order />} />
              <Route path="/chat" element={<ChatEnhanced />} />
              <Route path="/automation" element={<Automation />} />
              <Route path="/models" element={<ModelDatabase />} />
              <Route path="/api-settings" element={<APISettings />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/models" element={<AdminModels />} />
              <Route path="/upgrade" element={<Upgrade />} />
              <Route path="/auth/reset" element={<AuthReset />} />
              <Route path="/privacy"   element={<Privacy />} />
              <Route path="/terms"     element={<Terms />} />
              <Route path="/refund"    element={<Refund />} />
            </Routes>
          </div>
          {!isHome && <Footer />}
          <MrSupport />
          <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-gradient-to-br from-gray-950 via-blue-950 to-gray-950">
      <BrowserRouter>
        <AuthProvider>
          <Shell />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
